// extracted by mini-css-extract-plugin
export default {"wallet":"N8t5B","wallet__container":"SrOhi","wallet__imageMobile":"PuKzu","wallet__image":"vDLPo","wallet__content":"hxlOI","wallet__title":"WPmwr","wallet__description":"N_43l"};